import * as angular from "angular";

angular
  .module('bringoz.admin.site-preferences', [
    'bringoz.admin.iam'
  ]);
